import type { CartItem } from './types'

const CART_KEY = 'squish-prints-cart'

export function getCart(): CartItem[] {
  if (typeof window === 'undefined') return []
  const cart = localStorage.getItem(CART_KEY)
  return cart ? JSON.parse(cart) : []
}

export function saveCart(cart: CartItem[]): void {
  localStorage.setItem(CART_KEY, JSON.stringify(cart))
  // Dispatch custom event for cart updates
  window.dispatchEvent(new Event('cartUpdated'))
}

export function addToCart(item: Omit<CartItem, 'quantity'> & { quantity?: number }): void {
  const cart = getCart()
  const existingIndex = cart.findIndex(
    (i) => i.productId === item.productId && i.colorId === item.colorId
  )

  if (existingIndex >= 0) {
    cart[existingIndex].quantity += item.quantity || 1
  } else {
    cart.push({ ...item, quantity: item.quantity || 1 })
  }

  saveCart(cart)
}

export function updateCartItem(productId: string, colorId: string, quantity: number): void {
  const cart = getCart()
  const index = cart.findIndex(
    (i) => i.productId === productId && i.colorId === colorId
  )

  if (index >= 0) {
    if (quantity <= 0) {
      cart.splice(index, 1)
    } else {
      cart[index].quantity = quantity
    }
    saveCart(cart)
  }
}

export function removeFromCart(productId: string, colorId: string): void {
  const cart = getCart().filter(
    (i) => !(i.productId === productId && i.colorId === colorId)
  )
  saveCart(cart)
}

export function clearCart(): void {
  localStorage.removeItem(CART_KEY)
  window.dispatchEvent(new Event('cartUpdated'))
}

export function getCartTotal(): number {
  return getCart().reduce((total, item) => total + item.priceCents * item.quantity, 0)
}

export function getCartItemCount(): number {
  return getCart().reduce((count, item) => count + item.quantity, 0)
}
